import { AlertTriangle, Clock, ChevronRight } from 'lucide-react'
import { fd } from '@/lib/helpers'

interface Props {
  ocCriticas: any[]
  pendVencidas: any[]
  semRdo: any[]
  obraNome: (id: string) => string
  onOcorrenciaClick: (obraId: string) => void
  onPendenciaClick: (obraId: string) => void
  onObraClick: (obra: any) => void
}

export default function DashboardAlerts({ ocCriticas, pendVencidas, semRdo, obraNome, onOcorrenciaClick, onPendenciaClick, onObraClick }: Props) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-3">
      {/* Ocorrências críticas */}
      <div className="rounded-xl p-4 border" style={{ background: 'hsl(var(--bg2))', borderColor: 'hsl(var(--line))' }}>
        <div className="flex items-center gap-2 mb-3">
          <AlertTriangle size={14} style={{ color: 'hsl(var(--rose))' }} />
          <span className="text-sm font-bold text-foreground">Ocorrências Críticas</span>
          <span className="pill pill-rose text-[10px] ml-auto">{ocCriticas.length}</span>
        </div>
        <div className="space-y-2 max-h-[200px] overflow-y-auto">
          {ocCriticas.length === 0 ? (
            <p className="text-center py-4 text-xs text-muted-foreground">✓ Nenhuma ocorrência crítica</p>
          ) : ocCriticas.map((o: any) => (
            <div key={o.id} className="alert-row cursor-pointer" onClick={() => onOcorrenciaClick(o.obra_id)}>
              <div className="w-2 h-2 rounded-full flex-shrink-0" style={{ background: 'hsl(var(--rose))' }} />
              <div className="flex-1 min-w-0">
                <div className="text-xs font-medium text-foreground truncate">{o.titulo}</div>
                <div className="text-[10px] text-muted-foreground">{obraNome(o.obra_id)}</div>
              </div>
              <ChevronRight size={10} className="text-muted-foreground flex-shrink-0" />
            </div>
          ))}
        </div>
      </div>

      {/* Pendências vencidas */}
      <div className="rounded-xl p-4 border" style={{ background: 'hsl(var(--bg2))', borderColor: 'hsl(var(--line))' }}>
        <div className="flex items-center gap-2 mb-3">
          <Clock size={14} style={{ color: 'hsl(var(--amber))' }} />
          <span className="text-sm font-bold text-foreground">Pendências Vencidas</span>
          <span className="pill pill-amber text-[10px] ml-auto">{pendVencidas.length}</span>
        </div>
        <div className="space-y-2 max-h-[200px] overflow-y-auto">
          {pendVencidas.length === 0 ? (
            <p className="text-center py-4 text-xs text-muted-foreground">✓ Nenhuma pendência vencida</p>
          ) : pendVencidas.map((p: any) => (
            <div key={p.id} className="alert-row cursor-pointer" onClick={() => onPendenciaClick(p.obra_id)}>
              <div className="w-2 h-2 rounded-full flex-shrink-0" style={{ background: 'hsl(var(--amber))' }} />
              <div className="flex-1 min-w-0">
                <div className="text-xs font-medium text-foreground truncate">{p.nome}</div>
                <div className="text-[10px] text-muted-foreground">{obraNome(p.obra_id)} · Prazo: {fd(p.prazo)}</div>
              </div>
              <ChevronRight size={10} className="text-muted-foreground flex-shrink-0" />
            </div>
          ))}
        </div>
      </div>

      {/* Obras sem RDO */}
      <div className="rounded-xl p-4 border" style={{ background: 'hsl(var(--bg2))', borderColor: 'hsl(var(--line))' }}>
        <div className="flex items-center gap-2 mb-3">
          <AlertTriangle size={14} style={{ color: 'hsl(var(--amber))' }} />
          <span className="text-sm font-bold text-foreground">Sem RDO (3+ dias)</span>
          <span className="pill pill-amber text-[10px] ml-auto">{semRdo.length}</span>
        </div>
        <div className="space-y-2 max-h-[200px] overflow-y-auto">
          {semRdo.length === 0 ? (
            <p className="text-center py-4 text-xs text-muted-foreground">✓ Todas as obras com RDO em dia</p>
          ) : semRdo.map((o: any) => (
            <div key={o.id} className="alert-row cursor-pointer" onClick={() => onObraClick(o)}>
              <div className="w-2 h-2 rounded-full flex-shrink-0" style={{ background: 'hsl(var(--amber))' }} />
              <div className="flex-1 min-w-0">
                <div className="text-xs font-medium text-foreground truncate">{o.nome}</div>
                <div className="text-[10px] text-muted-foreground">
                  {o._lastRdoDays === 999 ? 'Nenhum RDO registrado' : `Último RDO há ${o._lastRdoDays} dias`}
                </div>
              </div>
              <ChevronRight size={10} className="text-muted-foreground flex-shrink-0" />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
